import _ from 'lodash';
import { getCookieObject } from './cookieHelpers/cookieHelpers';

const getDeviceType = () => {
  let deviceType = 'DESKTOP';

  // Determine which URL to use based on the device type.
  try {
    const cookieValue = getCookieObject('x-byo-config');

    // The cookie value should be a json data.  However, we have seen it as a String type.
    const deviceTypeObject = _.isString(cookieValue)
      ? JSON.parse(decodeURIComponent(cookieValue))
      : cookieValue;

    deviceType = deviceTypeObject
      ? _.toUpper(deviceTypeObject.deviceType)
      : 'DESKTOP';
  } catch (e) {} //eslint-disable-line no-empty

  return deviceType;
};

export default getDeviceType;
